import(/* webpackMode: "eager" */ "/vercel/path0/app/welcome/page.tsx");
